// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { LoginApi } from '../types/login.types';
import { loginHttpApi } from './login.api';
import { loginMockApi } from './login.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const loginApi: LoginApi = useMock ? loginMockApi : loginHttpApi;
